export default "__VITE_ASSET__92edf995__"